<template>
  <Standard
    v-if="visible"
    size="lg"
    modal_id="stuckWorkWarningModal"
    :title="$t('Stuck work warning')"
    :decline_label="$t('close')"
    :lightLayout="true"
    @close="close"
    @hidden="close"
  >
    <div class="p-4 text-start">
      <div class="alert alert-warning d-flex align-items-center mb-4" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16">
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.436-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg>
        <div>
          <strong>{{ $t('Stuck work warning subtitle', {
            department: payload?.department_name,
            count: payload?.stuck_count,
            hours: payload?.threshold_hours ?? 3
          }) }}</strong>
        </div>
      </div>

      <div class="mb-3">
        <h6 class="text-violet text-uppercase mb-2">{{ $t('Stuck work list title') }}</h6>
        <div class="table-responsive">
          <table class="table table-sm table-bordered table-hover mb-0">
            <thead class="bg-light-violet text-black">
              <tr>
                <th scope="col">{{ $t('Prescription') }}</th>
                <th scope="col">{{ $t('Delivery date') }}</th>
                <th scope="col">{{ $t('State') }}</th>
                <th scope="col">{{ $t('Phase') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="phase in payload?.stuck_phases?.slice(0, 10)"
                :key="phase.id"
              >
                <td>{{ phase.prescription_number ?? '-' }}</td>
                <td>{{ formatDate(phase.delivery_date) }}</td>
                <td>
                  <span class="badge" :class="stateBadgeClass(phase.state_slug)">
                    {{ phase.state_slug }}
                  </span>
                </td>
                <td>{{ phase.internal_phase_slug ?? '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <small v-if="payload && payload.stuck_count > Math.min(payload.stuck_phases?.length ?? 0, 10)" class="text-muted mt-1 d-block">
          {{ $t('Stuck work showing partial', { shown: Math.min(payload.stuck_phases?.length ?? 0, 10), total: payload.stuck_count }) }}
        </small>
      </div>
    </div>
  </Standard>
</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment';
import Standard from '@/components/Modal/Standard';

export default defineComponent({
  name: 'StuckWorkWarningModal',
  components: { Standard },
  props: {
    visible: { type: Boolean, default: false },
    payload: { type: Object, default: null },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const formatDate = (date) => {
      return date ? moment(date).format('DD/MM/YYYY') : '-';
    };

    const stateBadgeClass = (slug) => {
      const map = {
        'in-the-works': 'bg-secondary',
        'pending': 'bg-warning text-dark',
        'on-hold': 'bg-danger',
        'assigned': 'bg-info',
      };
      return map[slug] ?? 'bg-light text-dark';
    };

    const close = () => emit('close');

    return { formatDate, stateBadgeClass, close };
  },
});
</script>

